import { styled } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';

const FormControlForDataRangePicker = styled(FormControl, {
    shouldForwardProp: prop => prop !== 'isColumn',
})(({ isColumn }) => ({
    display: 'flex',
    flexDirection: isColumn ? 'column' : 'row',
    margin: 0,
}));

export default FormControlForDataRangePicker;
